module.exports = __webpack_public_path__ + "ploni-aaa-700.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ploni-aaa-700.otf
// module id = 1201
// module chunks = 10